export interface IAuthSuccess {
    token: string;
    expires: number;
    status_code: number;
    results: object;
}

export interface IsTokenExpired {
    status_code: number;
    message: string;
    token: string;
}

export interface IGetTokenPlayerSuccess {
    expires: number;
    token: string;
}

export function isAuthSuccess(object: any): object is IAuthSuccess {
    return (
        (object.status_code === 200) &&
        ('results' in object) &&
        ('token' in object['results']) &&
        ('expires' in object['results']) &&
        (typeof object['results'].token === 'string') &&
        (typeof object['results'].expires === 'number')
    );
}

export function isTokenExpired(object: any) : object is IsTokenExpired{
    return (
        (object.status_code === 400) && ( 'message' in object ) && (object.message.includes('expired'))
    );
}

export function isGetTokenSuccess(object: any) : object is IGetTokenPlayerSuccess{
    return (
        ('token' in object) 
    );
}
